import { apiPOST } from '../utils/adapterFunctions'

export const recordGaData = async (model) => {
  return await apiPOST('/ga-tracking/deposit', model)
}